import { Button } from '@mui/material';
import type { IOrgUnitDetailDTO } from '@sharedInterfaces/IOrgUnit';
import CardBox from '@src/App/Components/Cards/CardBox/CardBox';
import OrgUnitCard from '@src/App/Components/Cards/EntityCards/OrgUnits/ProjectCard/OrgUnitCard';
import { Container } from '@src/App/Components/Core/Layouts/LayoutElements/Container/Container';
import React, { useState } from 'react';

interface SubordinateOrgUnitsCardProps {
    subordinateOrgUnits: IOrgUnitDetailDTO[];
}

function SubordinateOrgUnitsCard({ subordinateOrgUnits }: SubordinateOrgUnitsCardProps) {
    const [showAll, setShowAll] = useState(false);
    const displayedOrgUnits = showAll ? subordinateOrgUnits : subordinateOrgUnits.slice(0, 3);

    return (
        <CardBox title="Untergeordnete Organisationseinheiten">
            <Container>
                {displayedOrgUnits.map((ou) => (
                    <OrgUnitCard key={ou.id} entity={ou} isSelected={false} showCheckbox={false} onSelect={() => {}} />
                ))}
                {subordinateOrgUnits.length > 3 && (
                    <Button variant="text" onClick={() => setShowAll(!showAll)} sx={{ mt: 1 }}>
                        {showAll ? 'Weniger anzeigen' : 'Alle anzeigen'}
                    </Button>
                )}
            </Container>
        </CardBox>
    );
}

export default SubordinateOrgUnitsCard;
